import React from "react";

// "Found your opponent?" close dialog (design Frame 4). Two friendly outcomes —
// Matched (moves to the Matched tab) or Just close — plus Cancel. Either way the
// applicants only ever see "Request closed", never a rejection (BE-enforced).
const CloseRequestDialog = ({ request, onChoose, onCancel, busy }) => {
  if (!request) return null;
  const summary = [request.team_category_label, request.date?.phrase].filter(Boolean).join(" · ");
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/45 p-4" role="dialog" aria-modal="true">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-6">
        <h3 className="text-[16px] font-bold text-[#0F1728]">Found your opponent?</h3>
        <p className="text-[13px] text-[#66707F] mt-1">Closing {summary}.</p>
        <div className="mt-4 flex flex-col gap-2">
          <button
            onClick={() => onChoose("matched")}
            disabled={busy}
            className="w-full text-left rounded-lg border border-[#17B26A] bg-[#F0FBF5] px-4 py-3 hover:bg-[#E7F6EF] disabled:opacity-50"
            data-testid="close-matched"
          >
            <div className="text-[13.5px] font-semibold text-[#0E7B52]">Matched: we found our opponent</div>
            <div className="text-[11.5px] text-[#3E8B63]">Moves to your Matched tab.</div>
          </button>
          <button
            onClick={() => onChoose("just_close")}
            disabled={busy}
            className="w-full text-left rounded-lg border border-[#E0E6EE] px-4 py-3 hover:bg-gray-50 disabled:opacity-50"
            data-testid="close-just"
          >
            <div className="text-[13.5px] font-semibold text-[#33475E]">Just close it</div>
            <div className="text-[11.5px] text-[#98A2B3]">No longer needed.</div>
          </button>
        </div>
        <p className="mt-3 text-[11.5px] text-[#98A2B3]">Either way, applicants simply see "Request closed", never a rejection.</p>
        <div className="mt-4 flex justify-end">
          <button onClick={onCancel} disabled={busy} className="px-4 py-2 rounded-lg border border-[#E0E6EE] text-[13px] font-semibold text-[#33475E] hover:bg-gray-50">Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default CloseRequestDialog;
